module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-card-management.7d4bffb7.png";